import { Tag } from "antd";
import { PartsOptions, ActivationsOptions } from "Interfaces/UserClassification";
import { F_extra, MacroType } from "Types";
import { blue, green, red, volcano, gold, orange, cyan, geekblue, purple, magenta, grey } from '@ant-design/colors'


export const admin = 'admin'
export const manager = 'manager'
export const FETCH_CHAT_DELAY = 3000;
export const FETCH_CHAT_PAGE_SIZE = 25;
export const CHAR_STRING_SIZE = 255;
export const coach = 'coach'
export const user = 'user'
export const DATE_FORMAT_SHORT = "DD/MM/YY"; 
export const DATE_FORMAT = "YYYY-MM-DD"
export const DATE_FORMAT_HOURS_MINUTES = "YYYY-MM-DD HH:mm";
export const DATE_FORMAT_HOURS_MINUTES_SECONDS = "YYYY-MM-DD HH:mm:ss"
export const VIEW_PROFILE = 'VIEW_PROFILE'
export const VIEW_CHECK_INS = 'VIEW_CHECK_INS'
export const VIEW_FEEDBACK = 'VIEW_FEEDBACK'
export const VIEW_IMAGES = 'VIEW_IMAGES'
export const VIEW_IMAGE_DETAIL = 'VIEW_IMAGE_DETAIL'
export const VIEW_NOTES = 'VIEW_NOTES'
export const EDIT_NOTES = 'EDIT_NOTES'
export const VIEW_SMS = 'VIEW_SMS'
export const VIEW_NUTRITION = 'VIEW_NUTRITION';
export const EDIT_SMS = 'EDIT_SMS'
export const VIEW_MACRO_CALCULATOR = 'VIEW_MACRO_CALCULATOR'
export const EDIT_MACROS = 'EDIT_MACROS'
export const VIEW_QUESTIONNAIRE = 'VIEW_QUESTIONNAIRE'
export const THIS_WEEK = 'THIS_WEEK'
export const LAST_WEEK = 'LAST_WEEK'
export const LAST_MONTH = 'LAST_MONTH'
export const CLIENT = 'CLIENT'
export const COACH = 'COACH'
export const CHECKIN = 'CHECKIN'
export const ACTIVITY_REDUCER = 'ACTIVITY_REDUCER'
export const DASHBOARD_REDUCER = 'DASHBOARD_REDUCER'
export const COACHES_REDUCER = 'COACHES_REDUCER'
export const CHECK_IN_REDUCER = 'CHECK_IN_REDUCER'
export const USERS_REDUCER = 'USERS_REDUCER'
export const USER_NOTES_REDUCER = 'USER_NOTES_REDUCER'
export const MAX_FILE_SIZE = 5000000
export const ERROR_IMAGE = "data:image/png;base64,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"
export const PAGE_SIZE_OPTIONS = ['10', '20', '50', '100']
export const ACTIVATION_PART_ERROR = 'It is allowed to set user state classification for latest feedback from user only'
export const ONE_DAYS_MORE_LATE = "One days more late";
export const TWO_DAYS_MORE_LATE = "Two days more late";
export const CHAT_SEARCH_USERS = 'searchUsers';
export const MACRO_TYPES: MacroType[] = ['LowMacro', 'StandardMacro', 'HighMacro'];
export const SHOW_PERCENTAGE_CHART = 2.5;
export const REMINDER_PIN_TASK_DAYS = 3;
export const COLOR_CATEGORY_TONE = 5;
export const filterButtonData: {value: F_extra, text: string}[] = [
    {value: 'checkIn', text: 'Check-in'},
    {value: 'notCheckIn', text: 'Not Check-in'},
    {value: 'mia', text: 'MIA'},
]
export const DefaultPageSizes = {
    FEEDBACK: 10,
} as const;

export const goalOptions = [
    {
        value: "WEIGHT_LOSS",
        label: "Weight Loss",
    },
    {
        value: "MUSCLE_GAIN",
        label: "Muscle Gain",
    },
    {
        value: "RECOMP",
        label: "Recomposition",
    },
    {
        value: "MAINTENANCE",
        label: "Maintenance",
    },
]

export const actionData = [
    {text: "View Profile", value: VIEW_PROFILE},
    {text: "View Check Ins", value: VIEW_CHECK_INS},
    {text: 'View Feedback', value: VIEW_FEEDBACK},
    {text: 'View Images', value: VIEW_IMAGES},
    {text: 'View Image Detail', value: VIEW_IMAGE_DETAIL},
    {text: 'View Notes', value: VIEW_NOTES},
    {text: 'Edit Notes', value: EDIT_NOTES},
    {text: "View Macro Calculator", value: VIEW_MACRO_CALCULATOR},
    {text: 'Edit Macros', value: EDIT_MACROS},
    {text: 'View Nutrition', value: VIEW_NUTRITION},
    {text: 'View Questionnaire', value: VIEW_QUESTIONNAIRE},
    {text: 'View SMS', value: VIEW_SMS}
]

export const activationsOptions: {value: ActivationsOptions, label: string}[] = [
    {value: 'activation_low', label: 'Low'},
    {value: 'activation_steady', label: 'Steady'},
    {value: 'activation_high', label: 'High'},
    // {value: 'activation_ensure', label: 'Ensure'}
]

export const partsOptions: {value: PartsOptions, label: string, placement: string}[] = [
    {value: 'part_fight', label: 'Fight', placement: 'left'},
    {value: 'part_flight', label: 'Flight', placement: 'bottom'},
    {value: 'part_freeze', label: 'Freeze', placement: 'bottom'},
    {value: 'part_attach', label: 'Attach', placement: 'bottom'},
    {value: 'part_submit', label: 'Submit', placement: 'bottom'}
]

export const partsValues = partsOptions.reduce((acc: {[k: string]: string},{value, label}) =>({
    ...acc,
    [value]: label.toLowerCase()
}), {})

export const activationValues = activationsOptions.reduce((acc: {[k: string]: string}, {value, label}) => ({
    ...acc,
    [value]: label.toLowerCase()
}),{})


export const activationFilters = activationsOptions.reduce((acc: {text: string, value: ActivationsOptions}[],{value,label}) => ([
    ...acc,
    {text: label, value}
]), []);
export const partsFilters = partsOptions.reduce((acc: {value: PartsOptions, text: string}[], {value,label}) => [
    ...acc,
    {text: label, value}
],[]);
export const allParts = partsOptions.reduce((acc: PartsOptions[], {value}) => [...acc, value], [])
export const allActivations = activationsOptions.reduce((acc: ActivationsOptions[], {value}) => [...acc, value], [])

export const getHex = (color: typeof green) => color[COLOR_CATEGORY_TONE];
export const colorsHexCategoriesOptions = [
    {
        value: getHex(green),
        label: <Tag title={getHex(green)} color={getHex(green)}>Green</Tag>
    },
    {
        value: getHex(cyan),
        label: <Tag title={getHex(cyan)} color={getHex(cyan)}>Cyan</Tag>
    },
    {
        value: getHex(red),
        label: <Tag title={getHex(red)} color={getHex(red)}>Red</Tag>
    },
    {
        value: getHex(volcano),
        label: <Tag title={getHex(volcano)} color={getHex(volcano)}>Volcano</Tag>

    },
    {
        value: getHex(orange),
        label: <Tag title={getHex(orange)} color={getHex(orange)}>Orange</Tag>
    },
    {
        value: getHex(gold),
        label: <Tag title={getHex(gold)} color={getHex(gold)}>Gold</Tag>
    },
    {
        value: getHex(blue),
        label: <Tag title={getHex(blue)} color={getHex(blue)}>Blue</Tag>
    },
    {
        value: getHex(geekblue),
        label: <Tag title={getHex(geekblue)} color={getHex(geekblue)}>Geekblue</Tag>
    },
    {
        value: getHex(purple),
        label: <Tag title={getHex(purple)} color={getHex(purple)}>Purple</Tag>
    },
    {
        value: getHex(magenta),
        label: <Tag title={getHex(magenta)} color={getHex(magenta)}>Magenta</Tag>
    },
    {
        value: getHex(grey),
        label: <Tag title={getHex(grey)} color={getHex(grey)}>Grey</Tag>
    }
];